import dataSelect from "@store/dataForSelect/reducers";

import { skill_want_select } from "../../configs/constants";

export default dataSelect(skill_want_select);
